import {
  Col,
  Card,
  CardBody,
  Container,
  Row,
  FormGroup,
  Label,
  Button,
} from "reactstrap";
import { Btn } from "../../AbstractElements";
import { Income, LevelIncomeReport } from "../../utils/Constant";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";

//import { Formik, Field, FieldProps, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import { useEffect, useMemo, useState, ChangeEvent, FormEvent } from "react";
import { decryptData } from "../../utils/helper/Crypto";
import * as XLSX from "xlsx";
import { format } from "date-fns";
import { IoMdPrint } from "react-icons/io";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import DataTable from "react-data-table-component";
import { useCommonService } from "../../Service/CommonService/Commonservice";
import { useSweetAlert } from "../../Context/SweetAlertContext";
import Datanotfound from "../PageNotFound/Datanotfound";
import CustomPagination from "../CustomPagination";
import { FaPlus } from "react-icons/fa6";
import { IoSearchSharp } from "react-icons/io5";

interface FormValues {
  FromDate: Date | null;
  ToDate: Date | null;
}

const LevelIncomeComponent = () => {
  const { showAlert, ShowSuccessAlert } = useSweetAlert();
  const { ApiCalling } = useCommonService();

  ///-------------------------------------search report part-----------------------------------------------

  const [data, setData] = useState<any>([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [fromDate, setFromDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 30); // Default 30 days ago
    return date;
  });

  const [toDate, setToDate] = useState(new Date());
  const [filterText, setFilterText] = useState("");
  const [columns, setColumns] = useState<any[]>([]);

  const [cols, setCols] = useState<any[]>(() => columns); // ✅ NOT [columns]

  // first column ko fixed width do
  useEffect(() => {
    setCols(() =>
      columns.map((c, i) =>
        i === 1
          ? { ...c, width: "50px", minWidth: "50px", maxWidth: "50px", grow: 0 }
          : c
      )
    );
  }, [columns]);
  const heightOffset = 120;
  const [loading, setLoading] = useState(false);
  const [memberID, setmemberID] = useState(
    decryptData(localStorage.getItem("clientId") as string)
  );

  useEffect(() => {
    setmemberID(decryptData(localStorage.getItem("clientId") as string));
  }, []);

  // ✅ Unified Data Fetcher
  const FetchData = async (
    page = currentPage,
    size = perPage,
    search = filterText
  ) => {
    setLoading(true);

    const formattedFromDate = format(fromDate, "dd-MMMM-yyyy");
    const formattedToDate = format(toDate, "dd-MMMM-yyyy");

    const obj = {
      FromDate: formattedFromDate,
      ToDate: formattedToDate,
      ActionMode: "SelectByIdViewByMember",
      page,
      size,
      search,
      MemberId: memberID,
    };

    const param = {
      procName: "GetDirectIncome",
      Para: JSON.stringify(obj),
    };

    try {
      const res = await ApiCalling(param);

      if (Array.isArray(res) && res.length > 0) {
        // Remove TotalCount column from each object
        const cleanedData = res.map(({ TotalCount, ...rest }) => rest);

        //const keys = Object.keys(res[0] || {});
        const keys = Object.keys(cleanedData[0]);

        const list = keys.map((col) => ({
          name: col,
          selector: (row: any) => row[col],
          sortable: true,
          center: false,
          width: "auto",
          cell: (row: any) => (
            <div dangerouslySetInnerHTML={{ __html: row[col] }} />
          ),
        }));

        setColumns(list);
        setData(cleanedData);
        const total = res[0]?.TotalCount ?? 0;
        setTotalRows(total); // ✅ important
      } else {
        setColumns([]);
        setData([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error("Data fetch failed:", error);
    }

    setLoading(false);
  };

  // ✅ Search (onSubmit of form)
  const handleSubmit = (e: any) => {
    e.preventDefault();
    setCurrentPage(1); // Reset to first page
    FetchData(1, perPage, filterText); // Pulls fresh data
  };
  useEffect(() => {
    console.log("Effect triggered with", currentPage, perPage);
    FetchData(currentPage, perPage, filterText);
  }, [currentPage, perPage, filterText]);

  const exportAndPrintCSV = (data: any) => {
    debugger;
    if (data.length === 0) {
      showAlert("Oops!", "No data available at the moment.");
      return;
    }

    // Clean data and convert to CSV format
    const cleanedData = cleanDataForExport(data);
    const csvData = XLSX.utils.sheet_to_csv(
      XLSX.utils.json_to_sheet(cleanedData)
    );

    // Convert CSV data to an HTML table and print
    printCSVData(csvData);
  };
  // Function to convert CSV to HTML table and print
  const printCSVData = (csvData: string) => {
    const escapeHtml = (text: string) =>
      text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

    const rows = csvData
      .split("\n")
      .map((row) => row.split(","))
      .filter(
        (row) => row.length > 1 && row.some((cell) => cell.trim() !== "")
      );

    if (rows.length === 0) {
      alert("No valid data to print.");
      return;
    }

    const printWindow = window.open("", "", "height=900,width=1200");
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
      <html>
      <head>
        <title>Printable Report</title>
        <style>
          body { 
            font-family: Arial, sans-serif; 
            margin: 20px; 
            padding: 0;
            color: #333;
          }
          h2 {
            text-align: center;
            margin-bottom: 20px;
          }
          table { 
            width: 100%; 
            border-collapse: collapse; 
            font-size: 12px; 
          }
          th, td { 
            border: 1px solid #ddd; 
            padding: 6px; 
            text-align: left; 
          }
          th { 
            background-color: #f2f2f2; 
            font-weight: bold; 
          }
          td { 
            white-space: pre-wrap; 
            word-break: break-word;
          }
          @media print {
            body { margin: 10mm; }
            button { display: none; }
          }
        </style>
      </head>
      <body>
        <h2>Report</h2>
        <table>
          <thead>
            <tr>
              ${rows[0]
                .map((cell) => `<th>${escapeHtml(cell.trim())}</th>`)
                .join("")}
            </tr>
          </thead>
          <tbody>
            ${rows
              .slice(1)
              .map(
                (row) => `
              <tr>
                ${row
                  .map((cell) => `<td>${escapeHtml(cell.trim())}</td>`)
                  .join("")}
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() { window.close(); };
          };
        </script>
      </body>
      </html>
    `);
      printWindow.document.close();
      printWindow.focus();
    } else {
      console.error("Failed to open print window.");
    }
  };

  const cleanDataForExport = (data: any[]) => {
    return data.map((row) => {
      const cleanedRow: any = {};
      for (let key in row) {
        if (typeof row[key] === "string") {
          const div = document.createElement("div");
          div.innerHTML = row[key];
          const inputElement = div.querySelector("input");
          if (inputElement) {
            // Get the value of the input field
            cleanedRow[key] = inputElement.value || "";
          } else {
            cleanedRow[key] = div.textContent || div.innerText || "";
          }
        } else {
          cleanedRow[key] = row[key];
        }
      }
      return cleanedRow;
    });
  };

  const exportToExcel = (data: any) => {
    if (data.length === 0) {
      showAlert("Opps!", "No data available at the moment.");
      return;
    }

    // Clean data to remove HTML tags
    const cleanedData = cleanDataForExport(data);

    // Convert cleaned data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(cleanedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, "TableData.xlsx");
  };

  return (
    <>
      <div className="page-body">
        <Breadcrumbs
          mainTitle={LevelIncomeReport}
          parent={Income}
          ChildName={LevelIncomeReport}
        />
        <Container fluid className="innerPageCard">
          <form onSubmit={handleSubmit}>
            <Row>
              <Col xl="12">
                <Row>
                  <Col md="3">
                    <FormGroup>
                      <Label className="">From Date:</Label>
                      <DatePicker
                        className="form-control"
                        selected={fromDate}
                        onChange={(date: any) => setFromDate(date)}
                        dateFormat="dd-MMMM-yyyy"
                        placeholderText="dd-MMMM-yyyy"
                      />
                    </FormGroup>
                  </Col>

                  <Col md="3">
                    <FormGroup>
                      <Label className="">To Date:</Label>
                      <DatePicker
                        className="form-control"
                        selected={toDate}
                        onChange={(date: any) => setToDate(date)}
                        dateFormat="dd-MMMM-yyyy"
                        placeholderText="dd-MMMM-yyyy"
                      />
                    </FormGroup>
                  </Col>

                  <Col
                    md="3"
                    className="d-flex align-items-center justify-content-start pb-2 pb-md-0"
                  >
                    <button
                      type="submit"
                      className="btn btn-primary mt-0 mt-md-3"
                    >
                      <IoSearchSharp /> Search
                    </button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </form>

          <Col className="mb-3">
            <Card className="mb-3 p-2">
        <div
          className="table-shell"
          style={{
            height: `calc(100vh - ${heightOffset}px)`,
            minHeight: 360,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <DataTable
            data={data}
            columns={columns}
            pagination={false} // server-side / custom pager
            highlightOnHover
            subHeader
            // subHeaderComponent={subHeader}
            subHeaderComponent={
                <>
                 {loading ? (
          <Col
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "10px" }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </Col>
        ) : ('')}
                <Row className="p-0 m-0 align-items-center justify-content-between">
                   {data.length>0  || filterText !='' ?  (
                    <Col md={12} className="d-flex align-items-center position-relative">
                      <IoSearchSharp
                        className="position-absolute"
                        style={{
                          top: "50%",
                          left: "30px",
                          fontSize: "20px",
                          transform: "translateY(-50%)",
                          color: "#999",
                          pointerEvents: "none",
                        }}
                      />
                        
                      <input
                        className="form-control w-100 ps-5"
                        placeholder="Search value..."
                        value={filterText}
                        onChange={(e) => {
                          setFilterText(e.target.value);
                          setCurrentPage(1);
                          FetchData(1, perPage, e.target.value);
                        }}
                      />
                    </Col>
                   ):''}
 {/* {data.length>0 ? (
                    <Col md="auto" className="d-flex mt-2 mt-md-0 align-items-center">
                      <Btn
                        color="primary"
                        onClick={() => exportAndPrintCSV(data)}
                        style={{ marginRight: "10px" }}
                      >
                        <IoMdPrint size={20} /> Print
                      </Btn>
                      <Btn
                        color="primary"
                        onClick={() => exportToExcel(data)}
                      >
                        <PiMicrosoftExcelLogoFill size={20} /> Excel
                      </Btn>
                    </Col>
                    ):'' } */}
                  </Row>
                 
                </>
              }
            subHeaderAlign="right"
            fixedHeader
            fixedHeaderScrollHeight="calc(100vh - 220px)" // अपनी layout के हिसाब से adjust
            persistTableHead
            responsive
            dense
            progressPending={loading} // ✅ सही loader
            progressComponent={
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              
            }
            noDataComponent={<Datanotfound />}
            customStyles={{
              headCells: { style: { whiteSpace: "nowrap", fontWeight: 600 } },
              cells: {
                style: {
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
              },
              tableWrapper: { style: { overflow: "auto" } },
            }}
          />
          {data.length > 0 || filterText != "" ? (
            <CustomPagination
              currentPage={currentPage}
              perPage={perPage}
              totalRows={totalRows}
              onPageChange={(page: number) => {
                setCurrentPage(page);
                // FetchData(page, perPage, filterText);
              }}
              onRowsPerPageChange={(newPerPage: number) => {
                setPerPage(newPerPage);
                setCurrentPage(1);
                // FetchData(1, newPerPage, filterText);
              }}
            />
          ) : (
            ""
          )}
        </div>
        </Card>
          </Col>
        </Container>
      </div>
    </>
  );
};

export default LevelIncomeComponent;
